var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProposalSubmission({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.3333 16.6667V63.3333H16.6667V16.6667H63.3333ZM63.3333 10H16.6667C13 10 10 13 10 16.6667V63.3333C10 67 13 70 16.6667 70H63.3333C67 70 70 67 70 63.3333V16.6667C70 13 67 10 63.3333 10Z",
    fill: "url(#paint0_linear_259_31)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6668 56.6667H23.3335V50H46.6668V56.6667ZM56.6668 43.3333H23.3335V36.6667H56.6668V43.3333ZM56.6668 30H23.3335V23.3333H56.6668V30Z",
    fill: "url(#paint1_linear_259_31)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_259_31",
    x1: 11.4493,
    y1: 38.3902,
    x2: 70,
    y2: 38.3902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF986C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF756C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_259_31",
    x1: 24.1386,
    y1: 39.1057,
    x2: 56.6668,
    y2: 39.1057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF986C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF756C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProposalSubmission);
export default __webpack_public_path__ + "static/media/proposal-submission.53f9da68687b6175c16f61c00468536b.svg";
export { ForwardRef as ReactComponent };